encodeDotInKeys